var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1V6.5C21.067 6.5 19.5 8.067 19.5 10C19.5 11.933 21.067 13.5 23 13.5V19H1V13.5C2.933 13.5 4.5 11.933 4.5 10C4.5 8.067 2.933 6.5 1 6.5V1H23Z",
    stroke: "#3873FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50122 14.5447L16.5012 5.54468",
    stroke: "#3873FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25122 6.79468L8.75122 6.29468L9.25122 6.79468L8.75122 7.29468L8.25122 6.79468Z",
    stroke: "#3873FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7512 13.2947L15.2512 12.7947L15.7512 13.2947L15.2512 13.7947L14.7512 13.2947Z",
    stroke: "#3873FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransact);
export default __webpack_public_path__ + "static/media/transact.66367d5aeb88d7953c99ad69432986ea.svg";
export { ForwardRef as ReactComponent };